import {LeadTimePriceType} from "../types";
import {useAppState} from "../context";
import {Fragment, useEffect, useMemo, useState} from "react";

export type LeadTimePriceInputProps = {
    initialValue?: number;
    onChange?: (value: LeadTimePriceType) => void;
    uiVariant: 'cart' | 'product';
}

export const LeadTimePriceInput = ({
                                       initialValue = undefined,
                                       onChange,
                                       uiVariant
                                   }: LeadTimePriceInputProps) => {

    const [leadTimePrices] = useAppState<LeadTimePriceType[]>('leadTimePrices', []);
    const [value, setValue] = useState<number | undefined>(initialValue);

    useEffect(() => {
        if (value !== initialValue && typeof onChange === 'function') {
            const v = leadTimePrices.find(v => v.id === value);
            if (v) {
                onChange(v);
            }
        }
    }, [value]);

    const ProductWrapper: React.FC<{ children: React.ReactNode }> = ({children}) => {
        return <div className="product__extra-col">{children}</div>
    }

    return useMemo(() => (leadTimePrices.map((leadTimePrice, index) => {

            const Wrapper = uiVariant === 'product' ? ProductWrapper:Fragment;

            return <Wrapper key={index}>
                <label className="btnradiocheck">
                    <input type="radio" className="btnradiocheck__input"
                           checked={(value ? value === leadTimePrice.id : (leadTimePrice.price === 0))}
                           onChange={() => {
                               setValue(leadTimePrice.id);
                           }}/>
                    {uiVariant === 'cart' &&
                        <span className="btnradiocheck__btn">
						{leadTimePrice.caption}
                            <span className="btnradiocheck__large-text">${leadTimePrice.price}</span>
					</span>
                    }
                    {uiVariant === 'product' &&
                        <>
                            <span className="btnradiocheck__label">{leadTimePrice.caption}</span>
                            <span className="btnradiocheck__btn">${leadTimePrice.price}</span>
                        </>
                    }
                </label>
            </Wrapper>
        })), [leadTimePrices, value, uiVariant])
}

export default LeadTimePriceInput;